const EngageAppAgent = 'Engage Mobile';

type IsEngageAppAppEmbedView = () => boolean;
export const isEngageAppEmbedView: IsEngageAppAppEmbedView = () =>
  typeof navigator !== 'undefined' && navigator.userAgent.includes(EngageAppAgent);
